import { render, staticRenderFns } from "./EcommerceOrderChart2.vue?vue&type=template&id=9f30dabc"
import script from "./EcommerceOrderChart2.vue?vue&type=script&lang=js"
export * from "./EcommerceOrderChart2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports